const CarSvg3 = () => {
  return (
    <svg
      width="104"
      height="97"
      viewBox="0 0 104 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M83.9286 0C80.6194 0 23.7252 0 20.0773 0L0 27.378L52.2157 96.1977L104 27.3701L83.9286 0ZM28.5454 30.3858L43.2566 74.336L9.91022 30.3858H28.5454ZM34.9542 30.3858H69.0697L52.129 81.6966L34.9542 30.3858ZM75.4698 30.3858H94.1262L60.8812 74.5722L75.4698 30.3858ZM80.8487 6.07716L94.2184 24.3086H75.4738L69.4917 6.07716H80.8487ZM63.0957 6.07716L69.0778 24.3086H34.9278L40.91 6.07716H63.0957ZM23.1568 6.07716H34.5138L28.5316 24.3086H9.78706L23.1568 6.07716Z"
        fill="#12273D"
      />
    </svg>
  );
};

export default CarSvg3;
